/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const leadNextStepResponseDtoSchema = z.object({
    "description": z.string(),
"dueAt": z.optional(z.string()),
"createdAt": z.string()
    })